import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

// TradingView Advanced Chart Widget
export default function App() {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Detect mobile
    const checkMobile = () => setIsMobile(window.innerWidth < 768)
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  useEffect(() => {
    if (!containerRef.current) return

    // Clear any existing widget
    containerRef.current.innerHTML = ''

    // Create TradingView widget
    const script = document.createElement('script')
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js'
    script.type = 'text/javascript'
    script.async = true
    script.innerHTML = JSON.stringify({
      autosize: true,
      symbol: "BINANCE:BTCUSDT",
      interval: isMobile ? "15" : "60",
      timezone: "Europe/Berlin",
      theme: "dark",
      style: "1",
      locale: "en",
      enable_publishing: false,
      allow_symbol_change: true,
      calendar: false,
      support_host: "https://www.tradingview.com",
      hide_top_toolbar: isMobile,
      hide_legend: isMobile,
      save_image: !isMobile,
      hide_volume: isMobile,
      studies: isMobile ? [] : ["STD;RSI", "STD;MACD"],
      show_popup_button: !isMobile,
      popup_width: "1000",
      popup_height: "650",
      withdateranges: !isMobile,
      details: !isMobile,
      hotlist: !isMobile,
      watchlist: !isMobile,
      watchlist_symbols: [
        { s: "BINANCE:BTCUSDT" },
        { s: "BINANCE:ETHUSDT" },
        { s: "FX:EURUSD" },
        { s: "FX:GBPUSD" },
        { s: "OANDA:XAUUSD" },
        { s: "NASDAQ:AAPL" },
        { s: "NASDAQ:TSLA" },
      ]
    })

    const widgetContainer = document.createElement('div')
    widgetContainer.className = 'tradingview-widget-container'
    widgetContainer.style.height = '100%'
    widgetContainer.style.width = '100%'
    
    const widgetInner = document.createElement('div')
    widgetInner.className = 'tradingview-widget-container__widget'
    widgetInner.style.height = 'calc(100% - 32px)'
    widgetInner.style.width = '100%'
    
    widgetContainer.appendChild(widgetInner)
    widgetContainer.appendChild(script)
    containerRef.current.appendChild(widgetContainer)

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = ''
      }
    }
  }, [isMobile])

  return (
    <div className="h-screen w-screen flex flex-col bg-[#131722]">
      {/* Top Bar */}
      <header className="flex items-center gap-2 sm:gap-4 px-2 sm:px-4 py-2 bg-[#1e222d] border-b border-[#363c4e]">
        <Link 
          to="/" 
          className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 rounded bg-[#131722] hover:bg-[#2a2e39] transition-colors text-gray-300"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          <span className="text-xs sm:text-sm hidden xs:inline">Back</span>
        </Link>
        
        <div className="flex-1" />
        
        <div className="flex items-center gap-1 sm:gap-2 text-gray-400 text-xs sm:text-sm">
          <span className="text-cyan-400 font-bold">K.I.T.</span>
          <span className="hidden sm:inline">Charts</span>
          <span className="text-[10px] sm:text-xs bg-green-500/20 text-green-400 px-1 sm:px-2 py-0.5 rounded">TRADINGVIEW</span>
        </div>
      </header>

      {/* TradingView Widget */}
      <div ref={containerRef} className="flex-1 min-h-0" />
    </div>
  )
}
